'use strict'

export default [
  {
    name: "stageDescription",
    fields: [
      { name: "name" },
      { name: "identifier", optional: true, _excludedFor: [ "project"] },
      { name: "description", height: 2 },
      { name: "prerequisite", height: 2, _excludedFor: [ "product" ] },
    ]
  },
  {
    name: "stageContext",
    _excludedFor: ["product"],
    fields: [
      { name: "externalDependencies", height: 2 },
      { name: "assumptions", height: 2 },
      { name: "stageApproach", height: 2 },
      { name: "lessonsIncorporated", height: 2 },
      { name: "monitorAndControl", height: 2 }
    ],
  },
  {
    name: "stageTime",
    fields: [
      { name: "period", type:"period" },
      { name: "timeTolerance" },
      { name: "timeToleranceUnit", options:[{value:"days"},{value:"weeks"},{value:"months"}] },
      { name: "timeComments", height: 2 }
    ]
  },
  {
    name: "stageCost",
    fields: [
      { name: "budget", type:"table",
        options: {
          summaryRow: true
        },
        columns: [
          { name: "element" },
          { name: "cost", editable: "true" },
          { name: "tolerance", editable: "true" },
          { name: "comment", editable: "true" }
        ]
      }
    ]
  },
  {
    name: "stageScheduleScope",
    fields: [
      { name: "scheduleComments", height:3 }
/*
      { name: "plan", type:"table",
        columns: [
          { name: "workPackage" },
          { name: "owner" },
          { name: "dueDate" },
          { name: "status" },
          { name: "comment" }
        ],
        options: {
          addEntry: [
            { name: "workPackage ", fields: [ {name: "product" } ]}
          ]
        }
      }
*/
    ]
  }
];



// WEBPACK FOOTER //
// ./views/plan/stageFormDefinition.js